
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientCustom } from './http-client';
import { SERVICE_URL } from '../constants/global';
import { ReturnStatusHtml } from '../models/returnStatus';
import { CostCenterConfig } from '../models/costCenterConfig';
import { of as observableOf, Observable } from 'rxjs';
import { MasterService } from './master.service';
// ***__***_________  MODULOS _________ ***__***
import { ErrorTreatmentFunctions } from '../modules/treatments.module';
import { CostCenter } from '../models/costCenter';

@Injectable()
export class CostCenterConfigService {
  private _analisysAxes: Array<any>;
  private _divisionKeys: Array<any>;
  private _allCostCenters: Array<any>;
  private _allCostCentersForAllCompanies: Array<any>;
  private _userCostCenters: Array<any>;

  private _controller: string = 'CostCenter';

  constructor(private http: HttpClientCustom, private _masterService: MasterService, private _errorTreat: ErrorTreatmentFunctions) { }

  public get allCostCenters(): Observable<Array<any>> {
    if (this._allCostCenters === undefined) {
      return this.getComplements('GetAll').pipe(map((response: ReturnStatusHtml) => {
        if (response.ReturnStatus.Successfull) {
          return this._allCostCenters = response.ReturnStatus.ReturnObject;
        } else {
          return new Array<any>();
        }
      }));
    } else {
      return observableOf(this._allCostCenters);
    }
  }

  public get allCostCentersForAllCompanies(): Observable<Array<any>> {
    if (this._allCostCentersForAllCompanies === undefined) {
      return this.getComplements('GetAllForAllCompanies').pipe(map((response: ReturnStatusHtml) => {
        if (response.ReturnStatus.Successfull) {
          return this._allCostCentersForAllCompanies = response.ReturnStatus.ReturnObject;
        } else {
          return new Array<any>();
        }
      }));
    } else {
      return observableOf(this._allCostCentersForAllCompanies);
    }
  }

  public getuserCostCenters(filteredByUser: boolean = true, filterActive: boolean = true): Observable<CostCenter[]> {
    if (this._userCostCenters === undefined) {
      return this.http.get(SERVICE_URL + this._controller + '/GetAll?filteredByUser=' + filteredByUser + '&filterActive=' + filterActive).pipe(
        map(response => {
          try {
            let responseReturn = this._masterService.convertToReturnStatusHtml(response);
            if (responseReturn.ReturnStatus.Successfull) {
              this._userCostCenters = responseReturn.ReturnStatus.ReturnObject as CostCenter[];
              return this._userCostCenters;
            } else {
              this._errorTreat.treatErrorResponseSendEmpty(responseReturn);
            }
          } catch (error) {
            this._masterService.handleError(error);
          }
        }));
    } else {
      return observableOf(this._userCostCenters);
    }
  }

  public get analisysAxes(): Observable<Array<any>> {
    if (this._analisysAxes === undefined) {
      return this.http.get(SERVICE_URL + 'AnalisysAxes/GetAll').pipe(
        map(response => {
          try {
            let responseReturn = this._masterService.convertToReturnStatusHtml(response);
            if (responseReturn.ReturnStatus.Successfull) {
              return this._analisysAxes = responseReturn.ReturnStatus.ReturnObject;
            } else {
              this._errorTreat.treatErrorResponseSendEmpty(responseReturn);
            }
          } catch (error) {
            this._masterService.handleError(error);
          }
        }));
    } else {
      return observableOf(this._analisysAxes);
    }
  }

  public get divisionKeys(): Observable<Array<any>> {
    if (this._divisionKeys === undefined) {
      return this.http.get(SERVICE_URL + 'DivisionKeys/GetAll').pipe(
        map(response => {
          try {
            let responseReturn = this._masterService.convertToReturnStatusHtml(response);
            if (responseReturn.ReturnStatus.Successfull) {
              return this._divisionKeys = responseReturn.ReturnStatus.ReturnObject;
            } else {
              this._errorTreat.treatErrorResponseSendEmpty(responseReturn);
            }
          } catch (error) {
            this._masterService.handleError(error);
          }
        }));
    } else {
      return observableOf(this._divisionKeys);
    }
  }

  public getCostCenters(analisysAxeID: number, documentType: string): Observable<ReturnStatusHtml> {
    return this.http.get(SERVICE_URL + this._controller + '/GetCostCentersListByAnalisysAxeAndDocumentType?analisysAxeID=' + analisysAxeID + '&documentType=' + documentType).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  getComplements(action: string): Observable<ReturnStatusHtml> {
    return this.http.get(SERVICE_URL + this._controller + '/' + action).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  /**
   * Criar/editar/eliminar centro de custo config
   * @param  {string} context
   * @param  {number} entityID
   * @param  {Array<CostCenterConfig>} configList
   * @returns Observable
   */
  updateCostCenterConfig(context: string, entityID: number, configList: Array<CostCenterConfig>): Observable<ReturnStatusHtml> {
    return this.http.post(SERVICE_URL + this._controller + '/UpdateCostCenterConfig', { context, entityID, configList }).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

}
